import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ChangePasswordLayer from "../../../components/Admin/ChangePasswordLayer";
import AdminBankAccountLayer from "../../../components/Admin/AdminBankAccountLayer";

const AdminBankAccount = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AdminBankAccountLayer />
      </MasterLayout>
    </>
  );
};

export default AdminBankAccount;